export const MEDIA_SECTION = Object.freeze({
  MY: 'MY',
  TEAM: 'TEAM'
});
